import React from 'react';
import { useStudioTypeSize } from '../../StudioTypeScale';
import SpotlightFrame, { type SpotlightInjectedProps, type SpotlightLayoutProps } from './SpotlightFrame';

const SpotlightTitleBulletsContent: React.FC<SpotlightInjectedProps & { content: any }> = ({
  content,
  tokens,
  isStory
}) => {
  const t = tokens!;
  const typeSize = useStudioTypeSize();
  const bullets = Array.isArray(content.bullets) ? content.bullets : [];

  return (
    <div>
      <h2
        style={{
          maxWidth: 310,
          margin: 0,
          color: t.ink,
          fontSize: typeSize(isStory ? 34 : 27),
          fontWeight: 900,
          letterSpacing: '-1.2px',
          lineHeight: 1.08
        }}
      >
        {content.title}
      </h2>
      {content.subtitle ? (
        <p
          style={{
            maxWidth: 294,
            margin: isStory ? '10px 0 0' : '8px 0 0',
            color: t.muted,
            fontSize: typeSize(isStory ? 13 : 11),
            fontWeight: 550,
            lineHeight: 1.48
          }}
        >
          {content.subtitle}
        </p>
      ) : null}
      <div style={{ display: 'flex', flexDirection: 'column', gap: isStory ? 10 : 7, marginTop: isStory ? 23 : 16 }}>
        {bullets.map((bullet: string, index: number) => (
          <div
            key={`${index}-${bullet}`}
            style={{
              position: 'relative',
              overflow: 'hidden',
              display: 'grid',
              gridTemplateColumns: isStory ? '42px 1fr' : '35px 1fr',
              gap: isStory ? 12 : 10,
              alignItems: 'center',
              padding: isStory ? '13px 14px 13px 10px' : '10px 11px 10px 8px',
              border: `1px solid ${t.line}`,
              background: t.panel
            }}
          >
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: isStory ? 35 : 29,
                height: isStory ? 35 : 29,
                color: t.onAccent,
                background: t.accent,
                fontSize: typeSize(isStory ? 14 : 12),
                fontWeight: 900,
                transform: 'skewX(-8deg)'
              }}
            >
              {index + 1}
            </span>
            <span
              style={{
                position: 'relative',
                zIndex: 1,
                color: t.ink,
                fontSize: typeSize(isStory ? 13.5 : 11.5),
                fontWeight: 700,
                lineHeight: 1.4
              }}
            >
              {bullet}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

const SpotlightTitleBulletsLayout: React.FC<SpotlightLayoutProps> = props => (
  <SpotlightFrame {...props}>
    <SpotlightTitleBulletsContent content={props.content || {}} />
  </SpotlightFrame>
);

export default SpotlightTitleBulletsLayout;
